import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import BasicSelect from 'app/ui_v2/form-fields/basic-fields/select/BasicSelect';

import { useQuery } from '@tanstack/react-query';

import { getDobAdmins } from '../helpers';

export interface AdminsSelectProps {
  control: any;
}

export default function AdminsSelect(props: AdminsSelectProps) {
  const { control } = props;

  const { isLoading, isError, error, data } = useQuery({
    queryKey: ['get-dob-admins-select'],
    queryFn: () => getDobAdmins(),
  });

  return (
    <>
      <BasicSelect
        collection={data ?? []}
        label="Assigned DOB Admin"
        inputName="reviewerId"
        control={control}
        disabled={isLoading}
        isLoading={isLoading}
      />
      {isError && error && <ErrorsList title="Unexpected loading error" errors={error as string[]} />}
    </>
  );
}
